// extracted by mini-css-extract-plugin
export default {"formContent":"LicenseForm_formContent__woNEc"};